var getUnixTimestamp = function () {
    return Date.now();
};
export default getUnixTimestamp;
